import React from "react";
import Select from "react-dropdown-select";
import Icon from "./Icon";

const SelectBox = ({
  title,
  option1,
  option2,
  option3,
  option4,
  val1,
  val2,
  val3,
  val4,
  onChange,
  wbox,
  options,
  selected,
  border1
}) => {
  var option;
  if(options){
     option=options
  }else{
     option = [
      { value: val4, label: option4 },
      { value: val1, label: option1 },
      { value: val2, label: option2 },
      { value: val3, label: option3 },
      
    ];
  }
  const selectValue = [];
  selectValue.push({ label: selected, value: selected });
  const border=border1?border1:' 2px solid #E9F1F9 '
  return (
    <div className="h-full flex items-center">
      <Select
        id="underline_select"
       
        onChange={onChange}
        
        options={option}
        direction="rtl"
        placeholder={title}
        values={selectValue}
        searchable={false}
        style={{width:wbox, border:border ,fontSize: '12px ',padding: "10px 15px ",alignItems:"center" }}
        dropdownHandleRenderer={({ state }) => (
          // if dropdown is open show "–" else show "+"
          <span className="arrow_icon" >
             <Icon  className=" w-3 h-3 inline-block"  iconName={"arrow-down"}/>
          </span>
        )}
      />
    </div>
  );
};

export default SelectBox;
// {state.dropdown ? (
//   <>
//     {/* <Icon
//       className=" w-3 h-3"
      
//       iconName={"arrow-up"}
//     /> */}
//       <Icon  className=" w-3 h-3 inline-block"  iconName={"arrow-down"}/>
//   </>
// ) : (
//   <>
//     <Icon  className=" w-3 h-3 inline-block"  iconName={"arrow-down"}/>
//   </>
// )}